import { graphql } from "gatsby";
import { Trans } from "gatsby-plugin-react-i18next";
import "photoswipe/dist/default-skin/default-skin.css";
import PhotoswipeUIDefault from "photoswipe/dist/photoswipe-ui-default";
import "photoswipe/dist/photoswipe.css";
import React, { useEffect, useRef, useState } from "react";
import { CustomGallery, DefaultLayout, Item } from "react-photoswipe-gallery";
import Layout from "./components/Layout";

export default function Products({ data }) {
  const includeAllString = "-1";
  const products = data.products?.nodes ?? [];
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [productTypesFilter, setProductTypesFilter] = useState([includeAllString]);
  const [showPlaceholders, setShowPlaceholders] = useState(true);
  const layoutRef = useRef();
  console.log(products);

  // Return classes based on whether item is checked
  const isChecked = item => (productTypesFilter.includes(item) ? " active" : "");

  // Add/Remove checked item from list
  function handleProductTypesFilterChecked(event) {
    debugger;
    var updatedList = [...productTypesFilter];
    if (!updatedList.includes(event.target.value)) {
      updatedList = [...productTypesFilter, event.target.value];
    } else {
      updatedList.splice(productTypesFilter.indexOf(event.target.value), 1);
    }
    setProductTypesFilter(updatedList);
  }

  useEffect(() => {
    setTimeout(() => {
      setShowPlaceholders(false);
    }, 350);
  }, []);

  useEffect(() => {
    let _filteredProducts = products;
    if (productTypesFilter.length > 0) {
      _filteredProducts = _filteredProducts.filter(
        x => productTypesFilter.includes(x.field_product_type) || productTypesFilter.includes(includeAllString)
      );
    }

    setFilteredProducts(_filteredProducts);
  }, [productTypesFilter]);

  return (
    <Layout>
      <main className="d-flex flex-fill">
        <div className="container px-4 px-md-3">
          <h1 className="my-5 text-center">
            <Trans>PRODUCTS</Trans>
          </h1>

          {showPlaceholders && (
            <div className="placeholder-container">
              <div className="row">
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
                  <div className="card" aria-hidden="true">
                    <svg
                      className="bd-placeholder-img card-img-top"
                      width="100%"
                      height="180"
                      xmlns="http://www.w3.org/2000/svg"
                      role="img"
                      aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice"
                      focusable="false"
                    >
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#a3a3a350"></rect>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div class={showPlaceholders ? " d-none" : ""}>
            <div className="product-filters mb-3">
              <div className="btn-group btn-group-sm" role="group" aria-label="Basic outlined example">
                <button
                  type="button"
                  className={"btn btn-outline-secondary" + isChecked(includeAllString)}
                  value={includeAllString}
                  onClick={handleProductTypesFilterChecked}
                >
                  Todos
                </button>
                <button
                  type="button"
                  className={"btn btn-outline-secondary" + isChecked("1")}
                  value="1"
                  onClick={handleProductTypesFilterChecked}
                >
                  Industrial
                </button>
                <button
                  type="button"
                  className={"btn btn-outline-secondary" + isChecked("2")}
                  value="2"
                  onClick={handleProductTypesFilterChecked}
                >
                  Antiguidades
                </button>
              </div>
            </div>

            {filteredProducts.length === 0 && (
              <span>Não foram encontrados resultados. Por favor redefina os seus critérios de pesquisa</span>
            )}

            <div className="macy-container2">
              <CustomGallery layoutRef={layoutRef} ui={PhotoswipeUIDefault}>
                {filteredProducts.map(product => (
                  <Item
                    key={product.drupal_id}
                    original={`https://v5.audacia.pt/${product.relationships.field_image.uri.url}`}
                    thumbnail={`${product.relationships.field_image.image_style_uri[0].large}`}
                    width={product.field_image?.width}
                    height={product.field_image?.height}
                    title={`<strong class="fs-1">${product.field_code}</strong><br><span class="fs-5">${product.field_description}</span>`}
                  >
                    {({ ref, open }) => (
                      <div className="product-container" onClick={open} onKeyDown={open}>
                        <img
                          className="demo-image"
                          ref={ref}
                          src={product.relationships.field_image.image_style_uri[0].large}
                          alt="Product"
                        />
                        <div className="overlay">
                          <div className="text-end">{product.field_code}</div>
                          <div className="fs-6">{product.title}</div>
                        </div>
                      </div>
                    )}
                  </Item>
                ))}
              </CustomGallery>

              <DefaultLayout shareButton={false} fullscreenButton={false} zoomButton={true} ref={layoutRef} />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

// export const query = graphql`
//   query ($language: String!) {
//     locales: allLocale(filter: { language: { eq: $language } }) {
//       edges {
//         node {
//           ns
//           data
//           language
//         }
//       }
//     }
//   }
// `;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    products: allNodeProduct {
      nodes {
        title
        field_code
        field_description
        field_product_type
        drupal_id
        relationships {
          field_image {
            image_style_uri {
              large
              wide
            }
            uri {
              url
            }
          }
        }
        field_image {
          height
          width
        }
        field_tags {
          drupal_internal__target_id
        }
      }
    }
  }
`;
